import React, { useState } from 'react';
import { Checkbox, Form } from 'components/ds';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { SCHEMA_STORAGE_KEY } from '../../services/SchemaService';
import { CheckboxGroup, FormContainer } from './TermsCheckboxes.styles';
import AcceptTermsModal from '../ModalTerms';
import { getArticle } from "../../utils/termsArticleUtils";

interface TermsCheckboxesProps {
  form?: any;
}

const TermsCheckboxes: React.FC<TermsCheckboxesProps> = ({ form: parentForm }) => {
  const [internalForm] = Form.useForm();
  const form = parentForm || internalForm;
  const schema = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
  const [visibleTermId, setVisibleTermId] = useState<string | null>(null);
  
  const visibleTerm = schema.terms?.find(
    (term: any) => term.id === visibleTermId,
  );
  
  const [checkboxValues, setCheckboxValues] = useState<Record<string, boolean>>(
    {},
  );
  
  const handleAgree = () => {
    if (visibleTermId) {
      const fieldName = `terms_${visibleTermId}`;
      const newValues = { ...checkboxValues, [fieldName]: true };
      setCheckboxValues(newValues);
      form.setFieldsValue(newValues);
      setVisibleTermId(null);
    }
  };
  
  const handleClose = () => {
    setVisibleTermId(null);
  };
  
  return (
    <FormContainer>
      <CheckboxGroup>
        {schema.terms?.map((term: any) => {
          const fieldName = `terms_${term.id}`;
          
          return (
            <Form.Item
              key={term.id}
              name={fieldName}
              valuePropName="checked"
              style={{ marginBottom: 0 }}
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(
                        new Error(
                          `Você precisa aceitar ${term.title.toLowerCase()}`,
                        ),
                      ),
                },
              ]}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Checkbox
                  checked={checkboxValues[fieldName]}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    if (isChecked) {
                      setVisibleTermId(term.id);
                    } else {
                      const newValues = { ...checkboxValues, [fieldName]: false };
                      setCheckboxValues(newValues);
                      form.setFieldsValue(newValues);
                    }
                  }}
                  style={{
                    marginTop: '4px'
                  }}
                />
                <span
                  style={{
                    cursor: 'pointer',
                    flex: 1,
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    color: 'var(--color-text)'  
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setVisibleTermId(term.id);
                  }}
                >
                  {`Li e aceito ${getArticle(term.title.toLowerCase())} ${term.title.toLowerCase()}`}
                </span>
              </div>
            </Form.Item>
          );
        })}
      </CheckboxGroup>
      
      {visibleTerm && (
        <AcceptTermsModal
          visible
          onClose={handleClose}
          onAgree={handleAgree}
          urlPDF={visibleTerm.contentUrl || ''}
          title={visibleTerm.title}
          message={`Li e aceito ${getArticle(visibleTerm.title.toLowerCase())} ${visibleTerm.title.toLowerCase()}`}
        />
      )}
    </FormContainer>
  );
};

export default TermsCheckboxes;
